import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ChevronDown, MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/lib/whatsapp";
import { SERVICES } from "@/data/services";

const linkClass = "text-sm font-medium text-slate-600 transition-colors hover:text-brand";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-100 bg-white/80 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-12">
        <Link to="/#inicio" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/logo.png" alt="Colors Limpieza" className="h-12 w-12 rounded-full object-cover" />
          <div className="leading-tight">
            <span className="font-display text-lg font-bold text-slate-900">Colors</span>
            <span className="block text-xs font-semibold uppercase tracking-widest text-brand">Limpieza</span>
          </div>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="desktop-nav">
          <div className="group relative">
            <button className="flex items-center gap-1 text-sm font-medium text-slate-600 transition-colors hover:text-brand" data-testid="nav-services-dropdown">
              Servicios <ChevronDown size={16} />
            </button>
            <div className="invisible absolute left-0 top-full z-50 w-64 pt-3 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100">
              <div className="rounded-2xl border border-slate-100 bg-white p-2 shadow-[0_20px_40px_-15px_rgba(15,23,42,0.15)]">
                {SERVICES.map((s) => (
                  <Link
                    key={s.slug}
                    to={`/servicios/${s.slug}`}
                    className="block rounded-xl px-4 py-3 text-sm font-medium text-slate-700 transition-colors hover:bg-brand-light hover:text-brand-dark"
                    data-testid={`nav-service-${s.slug}-link`}
                  >
                    {s.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <Link to="/#antes-despues" className={linkClass} data-testid="nav-antes-despues-link">Antes y después</Link>
          <Link to="/#cobertura" className={linkClass} data-testid="nav-cobertura-link">Cobertura</Link>
          <Link to="/blog" className={linkClass} data-testid="nav-blog-link">Blog</Link>
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-10 w-10 items-center justify-center rounded-full bg-[#25D366] text-white transition-transform hover:scale-105"
            aria-label="WhatsApp"
            data-testid="nav-whatsapp-button"
          >
            <MessageCircle size={18} />
          </a>
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-sunset px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_25px_-5px_rgba(255,162,89,0.4)] transition-colors hover:bg-sunset-dark"
            data-testid="nav-quote-button"
          >
            Cotizar gratis
          </a>
        </div>

        <button
          className="flex h-10 w-10 items-center justify-center rounded-xl text-slate-700 lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menú"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-100 bg-white px-4 py-4 lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col gap-1">
            <button
              onClick={() => setServicesOpen(!servicesOpen)}
              className="flex items-center justify-between rounded-xl px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50"
              data-testid="mobile-nav-services-toggle"
            >
              Servicios <ChevronDown size={16} className={`transition-transform ${servicesOpen ? "rotate-180" : ""}`} />
            </button>
            {servicesOpen &&
              SERVICES.map((s) => (
                <Link
                  key={s.slug}
                  to={`/servicios/${s.slug}`}
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-8 py-2.5 text-sm text-slate-600 hover:bg-brand-light hover:text-brand-dark"
                  data-testid={`mobile-nav-service-${s.slug}-link`}
                >
                  {s.name}
                </Link>
              ))}
            <Link to="/#antes-despues" onClick={() => setOpen(false)} className="rounded-xl px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50" data-testid="mobile-nav-antes-despues-link">Antes y después</Link>
            <Link to="/#cobertura" onClick={() => setOpen(false)} className="rounded-xl px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50" data-testid="mobile-nav-cobertura-link">Cobertura</Link>
            <Link to="/blog" onClick={() => setOpen(false)} className="rounded-xl px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50" data-testid="mobile-nav-blog-link">Blog</Link>
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 rounded-full bg-sunset px-5 py-3 text-center text-sm font-semibold text-white"
              data-testid="mobile-nav-quote-button"
            >
              Cotizar gratis
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
